import React from "react";
import cns from "classnames";
import { darken } from "polished";
import { makeStyles } from "@material-ui/core/styles";

import { ThemeType } from "@theme";
import BaseIconButton, { BaseIconButtonProps } from "./BaseIconButton";

const useStyles = makeStyles((theme: ThemeType) => ({
  root: {
    color: theme.bodyMainColor,

    "&:hover, &:active": {
      backgroundColor: darken(0.1, theme.palette.background.default)
    }
  },

  nonText: {
    backgroundColor: theme.palette.background.default
  }
}));

export const RegularButton: React.FC<BaseIconButtonProps> = ({
  children,
  className,
  ...rest
}) => {
  const classes = useStyles({});

  return (
    <BaseIconButton
      className={cns(classes.root, className, {
        [classes.nonText]: rest.variant !== "text"
      })}
      variant="contained"
      {...rest}
    >
      {children}
    </BaseIconButton>
  );
};

export default RegularButton;
